import loadable from "@loadable/component";
import { Carousel, CarouselProps } from "@tvg/fuse/carousel";
import useSlotConfig from "client/context/SlotConfig";
import useUser from "client/hooks/useUser";
import { isPersonalisedConfig } from "client/utils/amplience";
import userMeetsPersonalizationCriteria from "client/utils/userMeetsPersonalizationCriteria";
import React, { useMemo } from "react";

export interface HeroBannerProps extends Partial<CarouselProps> {}

const ImageHero = loadable(() => import(/* webpackChunkName: "ImageHero" */ "./ImageHero"));

export const HeroBanner: React.FC<HeroBannerProps> = (props) => {
  const { heroBanners } = useSlotConfig();
  const user = useUser();

  const filteredHeroBanners = useMemo(
    () =>
      heroBanners?.filter(
        (hb) => !isPersonalisedConfig(hb) || userMeetsPersonalizationCriteria(user, hb.personalization),
      ),
    [heroBanners, user],
  );

  if (!filteredHeroBanners?.length) return null;
  return (
    <Carousel
      dataTestId="content-hero-banner"
      chevronOverlay
      touchPeek={filteredHeroBanners.length > 1}
      lCardsPerPage={1}
      mCardsPerPage={1}
      xxsCardsPerPage={1}
      componentId="content-hero-banner"
      {...props}
    >
      {filteredHeroBanners.map((hb, idx) => (
        <ImageHero key={hb._meta.deliveryId} config={hb} position={idx} lazyLoad={idx !== 0} highPriority={idx === 0} />
      ))}
    </Carousel>
  );
};
